import { GeneralModel } from "./general.model";
import { Hub } from "./hub.model";

export class HubRouting extends GeneralModel {
    hubId: number;
    hub: Hub;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/models/hubRouting.model.ts